
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
	export class SingleAccountHoldingGrid extends AccountHoldingGrid {

		protected getInitialTitle() {
			return null;
		}

		protected getColumns() {
			return super.getColumns().filter(x => x.field != AccountHoldingRow.Fields.AccountCode);
		}

		protected getGridCanLoad() {
			return !!this._accountCode;
		}

		private _accountCode: string;

		public get accountCode() {
			return this._accountCode;
		}

		public set accountCode(value: string) {
			if (this._accountCode != value) {
				this._accountCode = value;
				this.setEquality(AccountHoldingRow.Fields.AccountCode, value);
				this.refresh();
			}
		}
	}
}